import dashboardRedux from '../../dashboard/redux/reducer';

//export redux objects
export default {
	dashboardRedux
};
